module.exports = __webpack_public_path__ + "img/Jump Casting2.66f84349.jpg";